import * as React from 'react';
import { NamedSettingsContext } from './named-settings-context';
import { useNamedSettings } from './named-settings-hook';
import { NamedSettingsProviderProps } from './named-settings-types';

export function NamedSettingsProvider({
  children,
  url,
  adminPermission,
}: React.PropsWithChildren<NamedSettingsProviderProps>) {
  const { context } = useNamedSettings(url, adminPermission);

  return (
    <NamedSettingsContext.Provider value={context}>
      {children}
    </NamedSettingsContext.Provider>
  );
}
